module.exports = __webpack_public_path__ + "img/text2.3377fcac.png";